<template>
    <h1 class="datepicker__container">
        {{$t('dashboard.datepickers.highlight')}}
        <!-- TODO: Create datepicker--readonly scss class -->
        <datepicker class="datepicker datepicker--readonly" v-model="highlight" :disabled="true"/>
        <!-- TODO: Style reset button -->
        <a class="datepicker__reset button" @click="onResetClicked">
            <i class="mdi mdi-close"></i>
        </a>
    </h1>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model} from 'vue-property-decorator';
    import Datepicker from '../general/Datepicker';
    import moment from 'moment';

    @Component({
        components: {
            Datepicker,
        }
    })
    export default class HighlightedDate extends Vue {
        @Model({
            type: Object,
            default: () => ({
                begin: null,
                end: null,
            })
        })
        daterange;

        get highlight() {
            return this.daterange.highlight.toDate();
        }

        set highlight(value) {
            if (value) {
                this.daterange.highlight = moment(value);
            } else {
                this.daterange.highlight = null;
            }
        }

        onResetClicked() {
            this.highlight = null;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/HighlightedDate.vue